









import { Component, Mixins } from 'vue-property-decorator'
import { packeryEvents } from 'vue-packery-plugin'
import { Getter } from 'vuex-class'
import imagesLoaded from 'vue-images-loaded'
import { TimelineLite } from 'gsap'

import { Meta } from '@/decorators/meta'
import PostsInstagram from '@/components/PostsInstagram.vue'
import Animation from '@/mixins/Animation.vue'

@Component({
  components: { PostsInstagram },
  directives: { imagesLoaded }
})
export default class Press extends Mixins(Animation) {
  posts = []

  @Getter('title') title

  @Meta
  metas() {
    return {
      title: 'Press',
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  async mounted() {
    const res = await this.$api.post.fetchPosts()
    this.posts = res.data
  }
}
